$(document).ready(function () {
    $(window).scrollTop($(window).scrollTop() + 0.1);
    $(window).scrollTop($(window).scrollTop() - 0.1);
});


// Initialize all Splide sliders
document.addEventListener('DOMContentLoaded', function () {
  // Standard Splide sliders (not smoothscroll)
  document.querySelectorAll('.splide:not([id^="smoothscroll"])').forEach(function (slider) {
    new Splide(slider, {
      perPage: 3,
      gap: "2rem",
      breakpoints: {
        480: {
          perPage: 1,
          gap: ".7rem"
        }
      }
    }).mount();
  });

  // Smooth auto-scroll sliders
  document.querySelectorAll('[id^="smoothscroll"]').forEach(function (slider) {
    new Splide(slider, {
      type: 'loop',
      drag: 'free',
      focus: 'center',
      direction: slider.getAttribute('data-direction'),
      arrows: false,
      autoWidth: true,
      pagination: false,
      perPage: 4,
      autoScroll: {
        speed: 0,
      },
    }).mount(window.splide.Extensions);
  });
});



// Define the custom element
customElements.define('abz-sticky-atc-trigger', class AbzStickyAtcTrigger extends HTMLElement {
  constructor() {
    super();
    this.observer = null;
    this.container = this.closest('form');
    console.log(this.container, 'kkk');
    if (!this.container) {
      return;
    }
    this.target = this.container.querySelector('.product-form__buttons');
    this.atcButton = this.container.querySelector('.product-form__submit');
    this.headerHeight = document.querySelector('.section-header') ? document.querySelector('.section-header').offsetHeight : 0;
  }

  connectedCallback() {
    if (!this.target || !this.atcButton) {
      return;
    }
    console.log(this.headerHeight, this.atcButton.offsetHeight);
    this.style.height = this.atcButton.offsetHeight + this.headerHeight + 'px';
    const options = {
      root: null, // Use viewport as root
      rootMargin: '0px',
      threshold: 0, // Trigger when 0% of element is visible
    };

    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        // Check if element is not intersecting (completely out of viewport)
        if (!entry.isIntersecting) {
          // Element is completely out of viewport
          this.target.classList.add('abz-sticky-atc');
        } else {
          this.target.classList.remove('abz-sticky-atc');
        }
      });
    };

    // Create and start observer
    this.observer = new IntersectionObserver(observerCallback, options);
    this.observer.observe(this);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
});
